export const FETCH_QUESTIONS_REQUEST = 'FETCH_QUESTIONS_REQUEST'
export const FETCH_QUESTIONS_SUCCESS = 'FETCH_QUESTIONS_SUCCESS'
export const FETCH_QUESTIONS_FAILURE = 'FETCH_QUESTIONS_FAILURE'
export const FETCH_QUESTIONS_UPDATE = 'FETCH_QUESTIONS_UPDATE'

